<template>
  <div>
    <!-- Start Breadcrumbs -->
    <div class="breadcrumbs">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6 col-12">
                    <div class="breadcrumbs-content">
                        <h1 class="page-title">Product List</h1>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-12">
                    <ul class="breadcrumb-nav">
                        <li><router-link to="/">Home</router-link></li>

                    </ul>
                </div>
            </div>
        </div>
    </div>
    <!-- End Breadcrumbs -->

    <!-- Start Category -->
    <section class="category-page section">
        <div class="container">
            <div class="row">
              <filter-component/>
              <product-list-vue/>
            </div>
        </div>
    </section>
    <!-- End Category -->
  </div>
</template>

<script>
import FilterComponent from '../components/FilterComponent.vue';
import ProductListVue from '../components/ProductList.vue';


export default {
  
  name: "HomePage",
  components: {
  FilterComponent,
  ProductListVue
  },
  computed:{
   
  },

  created() {
    this.$store.dispatch("fetchProducts");
    if (localStorage.access_token) {
        this.$store.dispatch("checkToken")
          .then(() => {
            let payload = { status: true };
            this.$store.commit("SET_LOGIN_STATUS", payload);
          })
          .catch((err) => {
            let payload = { status: false };
            this.$store.commit("SET_LOGIN_STATUS", payload);
            localStorage.clear();
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response.data.message,
              showCloseButton: true,
              showConfirmButton: false,
            });
          });
      } else {
        let payload = { status: false };
        this.$store.commit("SET_LOGIN_STATUS", payload);
        localStorage.clear();
        this.$router.push("/").catch(()=>{})
      }
  }
};
</script>

<style>
</style>